import React, { Component } from 'react';
import styles from './style.module.css';
import LB from '../../../../../assets/lb.jpg';
import GL from '../../../../../assets/gl.jpg';
import IG from '../../../../../assets/instagram.jpg';

class Contact extends Component {
    render() {
        return (
            <section id='contact' className={styles.sectionWrapper}>
                <div className={styles.maxWidth}>
                    <div className={styles.contentWrapper}>
                        
                        <div className={styles.working}>
                            <div className={styles.title}>Öffnungszeiten</div>
                            <span className={styles.data}>Montag - geschlossen</span>
                            <span className={styles.data}>Dienstag - 10:00 - 19:00</span>
                            <span className={styles.data}>Mittwoch - 10:00 - 19:00</span>
                            <span className={styles.data}>Donnerstag - 10:00 - 19:00</span>
                            <span className={styles.data}>Freitag -  10:00 - 19:00</span>
                            <span className={styles.data}>Samstag - 10:00 - 16:00</span>
                        </div>

                  <div className={styles.address}>
    <div className={styles.title}>Kontakt</div>

    <a
        href="https://buchung.treatwell.de/ort/yonchev-friseure/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.bookingBtn}
    >
        Einen Termin vereinbaren
    </a>

    <span className={styles.data}>
        <a
            href="https://www.instagram.com/yonchev.friseure"
            target="_blank"
            rel="noopener noreferrer"
        >
            Instagram <img src={IG} className={styles.ig} />
        </a>
    </span>

    <span className={styles.data}>
        <a
            href="https://www.google.de/maps/place/YONCHEV+Friseure/@48.1309559,11.5669708,15z"
            target="_blank"
            rel="noopener noreferrer"
        >
            Maistraße 21, 80337, München
        </a>
    </span>

    <span className={styles.data}>
        <a href="tel:017666333602">017 666 333 602</a>
    </span>

    <div className={styles.partner}>
        <div className={styles.title}>Partner</div>
        <div className={styles.partnerLogos}>
            <img src={LB} alt="Partner Logo 1" className={styles.partnerImg} />
            <img src={GL} alt="Partner Logo 2" className={styles.partnerImg} />
        </div>
    </div>
</div>

                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;